/**
 * The ICE configuration of every WebRTC surface (the view's scene, one connection per
 * media_server): the STUN list, plus this member's TURN server once its credentials arrive.
 * A browser behind a destination-dependent (CGNAT or symmetric) NAT completes no host or srflx
 * pair, and can stream only through its own TURN allocation.
 */

import type { TurnCredentials } from '@/types/turn';

// STUN-only fallback while the TURN credentials haven't been fetched yet (or
// the fetch failed). Same STUN servers media_server gathers against, so the
// browser also produces a `srflx` candidate.
export const kFallbackIceServers: RTCIceServer[] = [
    { urls: [
        'stun:stun.l.google.com:19302',
        'stun:stun1.l.google.com:19302',
        'stun:stun2.l.google.com:19302',
        'stun:stun.stunprotocol.org:3478',
    ] },
];

/**
 * The STUN list plus the TURN server. The credentials ride their own fields: the RFC 7635
 * username holds a colon and never goes into a URL.
 */
export function getIceServers(credentials: TurnCredentials): RTCIceServer[] {
    return [
        ...kFallbackIceServers,
        {
            urls: credentials.urls,
            username: credentials.username,
            credential: credentials.password,
        },
    ];
}
